var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "projects-page-outer" },
    [
      _vm.debugWindow ? _c("TheDebug") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: { "is-blurred": _vm.isLoading },
          attrs: { id: "projects-page" }
        },
        [
          _c("TheModal"),
          _vm._v(" "),
          _c("TheNavbar"),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "configurator-group" } },
            [
              _c("TheStepsSidebar"),
              _vm._v(" "),
              _c(
                "vue-custom-scrollbar",
                { staticClass: "sidenav" },
                [_c("router-view", { attrs: { name: "sidebar" } })],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { id: "workspace-group" } }, [
                _c(
                  "div",
                  { attrs: { id: "workspace" } },
                  [_c("router-view", { attrs: { name: "workspace" } })],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "lower-bar" } }, [
                  _c(
                    "div",
                    { staticClass: "lb-grid" },
                    [
                      _c("router-view", { attrs: { name: "lowerBarLeft" } }),
                      _vm._v(" "),
                      _c("router-view", {
                        attrs: { name: "lowerBarRight", version: "pro" }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Spinner", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }